/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExceptionResponseWithRetryAfterDTO } from './exception-response-with-retry-after-dto';
import { ExceptionResponseDTO } from './exception-response-dto';
import { ReadinessIssueDTO } from './readiness-issue-dto';
import { ExceptionResponseWithDetailsDTO } from './exception-response-with-details-dto';


/**
 * @type GetProfiloServizio422Response
 * @export
 */
export type GetProfiloServizio422Response = ExceptionResponseDTO | ExceptionResponseWithDetailsDTO | ExceptionResponseWithRetryAfterDTO;

